<template>
  <div>
    <el-input
      v-if="selectType == 1"
      v-model="selectText"
      :size="size"
      clearable
      @clear="clear()"
      style="width: 250px"
    >
      <template slot="append">
        <el-button
          @click="show()"
          :size="size"
          style="padding-left: 10px; padding-right: 10px"
        >
          <i class="el-icon-user"></i>
        </el-button>
      </template>
    </el-input>
    <el-link
      v-if="selectType == 2"
      type="primary"
      @click="show()"
      :underline="false"
      icon="el-icon-user"
    >
      {{ showName }}
    </el-link>
    <el-button
      v-if="selectType == 3"
      type="primary"
      plain
      @click="show()"
      icon="el-icon-user"
      :size="size"
    >
      {{ showName }}
    </el-button>
    <el-dialog
      :visible.sync="visable"
      title="选择员工"
      width="60%"
      top="5vh"
      :before-close="closeDialog"
      :modal="modal"
    >
      <el-row :gutter="10">
        <el-col :span="10">
          <el-tabs
            type="border-card"
            v-model="tabValue"
            @tab-click="tabChange()"
          >
            <el-tab-pane label="组织架构" name="department">
              <div class="department-list" v-loading="loading">
                <el-tree
                  :props="treeProps"
                  node-key="id"
                  :load="getDepartmentList"
                  lazy
                  @node-click="nodeClick"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="最近选择" name="recently">
              <div class="recently-list">
                <div
                  class="recently-item"
                  v-for="item in recentlyList"
                  :key="item.id"
                >
                  <a @click="handleSelect(item)">
                    {{ item.ancestor_name }}->{{ item.name }}
                  </a>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="14">
          <div class="search-keywords">
            <el-input
              v-model="keywords"
              style="width: 200px"
              clearable
              placeholder="输入关键字搜索"
            />
            <el-button
              type="primary"
              @click="searchByKeywords()"
              class="search-btn"
            >
              查询
            </el-button>
          </div>

          <el-table
            :data="searchList"
            size="mini"
            class="search-list"
            border
            v-loading="searchLoading"
            height="calc((90vh - 220px) / 2)"
          >
            <el-table-column>
              <template slot="header">
                <div class="search-header">
                  <span>搜索列表</span>
                  <el-button size="mini" @click="addAll()">
                    添加所有
                  </el-button>
                </div>
              </template>
              <template slot-scope="scope">
                <a class="user-item" @click="handleSelect(scope.row)">
                  {{ scope.row.ancestor_name }}->{{ scope.row.name }}
                </a>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            :current-page.sync="page"
            :page-size.sync="pageSize"
            class="pagination"
          />

          <el-table
            :data="selectedList"
            highlight-current-row
            @row-click="rowClick"
            border
            size="mini"
            class="selected-list"
            height="calc((90vh - 220px) / 2)"
          >
            <el-table-column prop="date" label="已选定人员">
              <template slot-scope="scope">
                <a class="user-item" @dblclick="handleRemove(scope.row)"
                  >{{ scope.row.ancestor_name }}->{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="button-list">
            <el-button type="primary" @click="onSelected()">确定</el-button>
            <el-button @click="removeSelected()" :disabled="!selectedRow"
              >删除选定</el-button
            >
            <el-button
              @click="clearSelected()"
              :disabled="selectedList.length == 0"
              >删除全部</el-button
            >
            <el-button @click="closeDialog()">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/components/Admin/Flow/common/Http";
import _ from "lodash";
export default {
  name: "UserSelect",
  props: {
    selectType: {
      type: Number,
      default: 1,
    },
    showName: {
      type: String,
      default: "选择发送员工",
    },
    modal: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      searchList: [],
      selectedList: [],
      selectedRow: null,
      page: 1,
      visable: false,
      pageSize: 20,
      total: 0,
      departmentId: 0,
      keywords: "",
      searchLoading: false,
      params: {},
      loading: false,
      treeProps: { label: "department_name" },
      treeKey: "",
      tabValue: "department",
      recentlyList: [],
      selectText: "",
      recentlyCacheKey: "recently-user-list",
    };
  },
  mounted() {},
  watch: {
    page(n, o) {
      this.getUserList();
    },
    departmentId(n, o) {
      this.getUserList();
    },
  },
  methods: {
    closeDialog() {
      this.visable = false;
      this.searchList = [];
      this.selectedList = [];
      this.selectedRow = null;
      this.page = 1;
      this.total = 0;
      this.departmentId = 0;
      this.keywords = "";
    },
    clearSelected() {
      this.selectedList = [];
    },
    handleRemove(data) {
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].id == data.id) {
          this.selectedList.splice(i, 1);
          break;
        }
      }
    },
    removeSelected() {
      this.handleRemove(this.selectedRow);
      this.selectedRow = null;
    },
    onSelected() {
      const data = _.cloneDeep(this.selectedList);
      let nameStr = data
        .map((item) => {
          return item.name;
        })
        .join(",");
      this.selectText = nameStr;
      this.cacheSelectedList(data);
      this.closeDialog();
      this.$emit("on-select", data);
    },
    cacheSelectedList(data) {
      let list = this.cache(this.recentlyCacheKey);
      let newList = [];
      if (list) {
        let newIds = data.map((item) => item.id);
        newList = list.filter((item) => newIds.includes(item.id) == false);
        data.forEach((item) => {
          newList.unshift(item);
        });
      } else {
        newList = data;
      }
      if (newList.length > 30) newList = newList.slice(0, 30);
      this.cache(this.recentlyCacheKey, newList);
    },
    /**
     * 缓存函数
     * @param {Object} key
     * @param {Object} value
     */
    cache(key, value) {
      if (value === undefined) {
        const res = localStorage.getItem(key);
        return res == null ? res : JSON.parse(res);
      } else if (value === null) {
        return localStorage.removeItem(key);
      } else {
        return localStorage.setItem(key, JSON.stringify(value));
      }
    },
    handleSelect(data) {
      if (_.some(this.selectedList, ["id", data.id]) == false) {
        this.selectedList.push(_.clone(data));
      }
    },
    addAll() {
      if (this.searchList.length > 0) {
        this.searchList.forEach((item) => {
          this.handleSelect(item);
        });
      }
    },
    rowClick(row) {
      this.selectedRow = row;
    },
    searchByKeywords() {
      this.params = { keywords: this.keywords };
      this.getUserList();
    },
    getUserList() {
      this.searchLoading = true;
      http.get(
        "hrm/user/nameList",
        Object.assign(
          { page: this.page, page_size: this.pageSize },
          this.params
        ),
        (res) => {
          if (res.code == 0) {
            this.searchList = res.data.list;
            this.total = res.data.total;
          } else {
            this.searchList = [];
            this.total = 0;
          }
          this.searchLoading = false;
        }
      );
    },
    getDepartmentList(node, resolve) {
      setTimeout(() => {
        let parent_id = 0;
        if (node.data != undefined) {
          parent_id = node.data.id;
        }
        if (parent_id == 0) this.loading = true;
        http.get("hrm/department/list", { parent_id: parent_id }, (res) => {
          var listData;
          listData = res.data.map((item) => {
            return {
              department_name: item.department_name,
              id: item.id,
            };
          });
          return resolve(listData);
        });
        this.loading = false;
      }, 300);
    },
    nodeClick(data) {
      this.departmentId = data.id;
      this.params = { department_id: this.departmentId };
    },
    tabChange() {
      if (this.tabValue == "recently") {
        this.recentlyList = this.cache(this.recentlyCacheKey);
      }
    },
    clear() {
      this.$emit("clear", []);
    },
    show() {
      this.treeKey = new Date().getTime();
      this.visable = true;
      this.tabChange();
    },
  },
};
</script>

<style lang="scss" scoped>
.department-list,
.recently-list {
  height: calc(90vh - 150px);
  min-height: 300px;
  max-height: 450px;
}

.department-list {
  overflow: auto;

  .tree-item {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .add-all {
      padding-right: 3px;
      font-size: 13px;
    }
  }

  .icon-item {
    margin-right: 3px;
  }
}

.search-list {
  width: 100%;
  height: calc((90vh - 220px) / 2);
  min-height: 120px;
  max-height: 192px;
  overflow: auto;
}

.selected-list {
  margin-top: 10px;
  width: 100%;
  height: calc((90vh - 220px) / 2);
  min-height: 120px;
  max-height: 192px;
  overflow: auto;
}

.pagination {
  margin: 0;
  padding: 5px;
  border: 1px solid var(--el-border-color-lighter);
  border-top: none;
}

.user-item {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.button-list {
  margin-top: 7px;
}

:deep(.el-table) {
  th.el-table__cell {
    background-color: #fdeef5;
  }
  .el-table__cell {
    padding: 3px 5px;
  }
}

.search-header {
  display: flex;
  justify-content: space-between;
}

.search-keywords {
  margin-bottom: 10px;

  .search-btn {
    margin-left: 10px;
  }
}

.recently-list {
  overflow: auto;
  .recently-item {
    font-size: 13px;
    line-height: 20px;
    border-bottom: 1px solid #fdeef5;
    padding: 5px 0;

    &:hover {
      background-color: #f5f7fa;
    }

    a {
      display: inline-block;
      cursor: pointer;
      color: #606266;
    }

    &:last-child {
      border: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/userSelect.vue